import {
  gridPageCountSelector,
  gridPageSelector,
  gridRowCountSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid'
import { Box, Chip, MenuItem, Pagination, Select, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useState } from 'react'

const StyledPagination = styled(Pagination)(({ theme }) => ({
  // Add your custom styles here
  '& .MuiPaginationItem-root': {
    backgroundColor: 'rgba(255, 255, 255, 1)',
    borderRadius: '6px',
    border: '1px solid rgba(0, 0, 0, 0.15)',
    color: '#000000',
    '&.Mui-selected': {
      backgroundColor: 'rgba(255, 255, 255, 1)',
      border: '2px solid rgba(50, 104, 185, 1)',
      color: '#000000',
      '&:hover': {
        backgroundColor: '#6B95EC',
      },
    },
    '&:hover': {
      color: 'white',
      backgroundColor: '#6B95EC',
    },
  },
}))

export default function ThemePagination() {
  const apiRef = useGridApiContext()
  const page = useGridSelector(apiRef, gridPageSelector)
  const pageCount = useGridSelector(apiRef, gridPageCountSelector)
  const rowCount = useGridSelector(apiRef, gridRowCountSelector)
  const totalCount = apiRef.current?.state?.rows?.totalRowCount ?? rowCount
  const [rowsPerPage, setRowsPerPage] = useState(5)

  const start = rowCount === 0 ? 0 : page * rowsPerPage + 1
  const end = Math.min((page + 1) * rowsPerPage, rowCount)
   const isFiltered = rowCount < totalCount
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value)
    apiRef.current.setPageSize(event.target.value)
  }

  return (
    <Box className="flex"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      sx={{ px: 5 }}
    >
      <Typography variant="caption" fontSize={14}>
        {rowCount > 0 ? (
          <>
      Showing <strong>{start}-{end}</strong> /{' '}
      <strong>{rowCount}</strong> records
      {isFiltered && (
    //     <Chip
    //   label="Filtered"
    //   size="small"
    //   color="primary"
    //   variant="outlined"
    //   sx={{
    //     height: 20,
    //     fontSize: '11px',
    //     '& .MuiChip-label': {
    //       px: 0.75,
    //     },
    //   }}
    // />
        <Typography
          component="span"
          variant="caption"
          sx={{ ml: 0.5, color: 'text.secondary' }}
        >
          (filtered)
        </Typography>
      )}
    </>
  ) : (
    'No records found'
  )}

        {/* Showing <strong>{rowCount}</strong> records */}
      </Typography>
      <Box display="flex" alignItems="center" gap={2}>
        <Select
          value={rowsPerPage}
          onChange={handleChangeRowsPerPage}
          displayEmpty
          size="small"
          variant="standard"
          inputProps={{ 'aria-label': 'Companies per page' }}
        >
          {[5, 10, 20, 50, 100].map((rows) => (
            <MenuItem key={rows} value={rows}>
              {rows}
            </MenuItem>
          ))}
        </Select>
        <StyledPagination
          color="primary"
          count={pageCount}
          page={page + 1}
          onChange={(event, value) =>
            apiRef.current.setPage(value - 1)
          }
        />
      </Box>
    </Box>
  )
}
